import React, { useState, useEffect, useRef, useCallback } from "react";
import "./Buypremium.css";
import { config } from "../config";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { analytics } from "../components/firebase";
import { logEvent } from "firebase/analytics";
import GoogleAuth from "../components/GoogleAuth";
import Leftpanel from "../components/leftPanel";

function PricingComponent({ showBackButton = true, showLeftPanel = true }) {
  const [activePlanId, setActivePlanId] = useState(null);
  const [subscribedPlanId, setSubscribedPlanId] = useState(null);
  const [plans, setPlans] = useState([]);
  const googleAuthRef = useRef(null);
  useEffect(() => {
    const fetchDodoPlans = async () => {
      try {
        const response = await fetch(`${config.baseURL}/get_dodo_plans.php`);
        if (!response.ok) throw new Error("Failed to fetch plans");
        const data = await response.json();
        const transformedPlans = data.items.map((item) => {
          return {
            id: item.product_id,
            name: item.name,
            currency: "USD",
            amount: item.price,
            interval:
              item.name === "Weekly"
                ? "1"
                : item.name === "Monthly"
                ? "2"
                : "2",
            intervalCount: item.name || 1,
          };
        });
        setPlans(transformedPlans);
        logEvent(analytics, "fetch plans legal", {});
      } catch (err) {}
    };

    fetchDodoPlans();
  }, []);


  const handleSubscribe = async (selectedPlanId) => {
    logEvent(analytics, "Subscribe button clicked landing page", {
      button_name: "legal_doc",
    });
    try {
      localStorage.setItem("selectedPlanIdForReuse", selectedPlanId);
      localStorage.setItem("isSubscribing", "true");

      const response = await fetch(`${config.baseURL}/validate_token.php`, {
        method: "GET",
        credentials: "include",
      });

      const data = await response.json();

      if (
        response.status !== 200 ||
        data.message === "Invalid token" ||
        data.error === "Wrong number of segments"
      ) {
        googleAuthRef.current.login();
        return;
      }

      localStorage.removeItem("isSubscribing");
      localStorage.removeItem("selectedPlanIdForReuse");

      const userEmail = data.user.email;
      const redirectUrl = `https://checkout.dodopayments.com/buy/${selectedPlanId}?quantity=1&redirect_url=https://legaldocumentgenerator.com/Dashboard&email=${encodeURIComponent(
        userEmail
      )}`;
      window.open(redirectUrl, "_blank");
    } catch (error) {
      console.error("Error while validating token:", error);
      alert("An error occurred. Please try again later.");
    }
  };

  const handleLoginSuccess = (response) => {
    console.log("Google login success:", response);
    checkSubscription();
    const isSubscribing = localStorage.getItem("isSubscribing") === "true";

    if (isSubscribing) {
      const selectedPlanId = localStorage.getItem("selectedPlanIdForReuse");
      if (selectedPlanId) {
        handleSubscribe(selectedPlanId);
      } else {
        toast.error("No plan selected.");
      }
    }
  };

  const handleLoginFailure = (error) => {
    toast.error("Google login failed. Please try again.");
  };

  const navigate = useNavigate();
  const handleBackClick = () => {
    navigate(-1);
  };

  const subtitles = [
    "Unleash the power of automation",
    "Advanced tools to take your Image to the next level.",
    "Automation plus enterprise-grade features",
  ];

  useEffect(() => {
    checkSubscription();
  }, []);

  const checkSubscription = async () => {
    try {
      const response = await fetch(`${config.baseURL}/check_subscription.php`, {
        method: "GET",
        credentials: "include",
      });

      const data = await response.json();

      if (data.error) {
      } else {
        localStorage.setItem(
          "subscriptionStatus",
          JSON.stringify(data.subscription_status)
        );
        localStorage.setItem("planId", JSON.stringify(data.plan_id));
        setSubscribedPlanId(data.plan_id);
      }
    } catch (error) {}
  };

  return (
    <div className="premium_layout_wrapper">
      {showLeftPanel ? (
        <div className="premium_with_panel">
          <Leftpanel />
          <div className="premium_page_lp">
            {showBackButton && (
              <button className="back-button-premium" onClick={handleBackClick}>
                <img src={config.Backbutton} alt="Back" />
              </button>
            )}

            <div className="subscription" id="Pricing">
              <div className="subscription_title">
                Simple, transparent pricing
              </div>
              <div className="plans_wrapper">
                {plans.map((plan, index) => {
                  const isSelected = plan.id === activePlanId;
                  const interval =
                    plan.name === "Weekly"
                      ? "Weekly"
                      : plan.name === "Half Yearly"
                      ? "Half Yearly"
                      : "Yearly";
                  return (
                    <div
                      key={plan.id}
                      className={`plan-box plan-${index + 1} ${
                        isSelected ? "selected-plan" : ""
                      }`}
                      onClick={() => setActivePlanId(plan.id)}
                    >
                      <div>
                        {plan.id === subscribedPlanId && (
                          <div Id="pro">Activated Plan</div>
                        )}
                        <div className="price_details">
                          <div className="price">${plan.amount / 100}</div>
                          <p className="price_interval">/{interval}</p>
                        </div>
                        <div className="description">
                          <div className="plan_name">{plan.name}</div>
                          {subtitles[index] && (
                            <div className="description_subtitle">
                              {subtitles[index]}
                            </div>
                          )}
                        </div>

                        <div className="points_list_full">
                          <div className="points_list_item">
                            <img
                              src={
                                isSelected
                                  ? config.check_point
                                  : config.colored_check_point
                              }
                              alt=""
                              className="colored_check"
                              width="20px"
                              height="20px"
                              style={{ visibility: "hidden" }}
                              onLoad={(e) =>
                                (e.target.style.visibility = "visible")
                              }
                            />
                            Generate Unlimited Legal Documents
                          </div>
                          <div className="points_list_item">
                            <img
                              src={
                                isSelected
                                  ? config.check_point
                                  : config.colored_check_point
                              }
                              alt=""
                              className="colored_check"
                              width="20px"
                              height="20px"
                              style={{ visibility: "hidden" }}
                              onLoad={(e) =>
                                (e.target.style.visibility = "visible")
                              }
                            />
                            Ask Unlimited Legal Doubts or Queries
                          </div>
                          <div className="points_list_item">
                            <img
                              src={
                                isSelected
                                  ? config.check_point
                                  : config.colored_check_point
                              }
                              alt=""
                              className="colored_check"
                              width="20px"
                              height="20px"
                              style={{ visibility: "hidden" }}
                              onLoad={(e) =>
                                (e.target.style.visibility = "visible")
                              }
                            />
                            Summarize & Analyze Legal Cases
                          </div>
                          <div className="points_list_item">
                            <img
                              src={
                                isSelected
                                  ? config.check_point
                                  : config.colored_check_point
                              }
                              alt=""
                              className="colored_check"
                              width="20px"
                              height="20px"
                              style={{ visibility: "hidden" }}
                              onLoad={(e) =>
                                (e.target.style.visibility = "visible")
                              }
                            />
                            Ads Free Experience
                          </div>
                        </div>
                      </div>
                      <button
                        className="choose_plan"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSubscribe(plan.id);
                        }}
                      >
                        Choose plan
                      </button>
                      <GoogleAuth
                        id="PremiumPageLogin"
                        ref={googleAuthRef}
                        onLoginSuccess={handleLoginSuccess}
                        onLoginFailure={handleLoginFailure}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="premium_page">
          {showBackButton && (
            <button className="back-button-premium" onClick={handleBackClick}>
              <img src={config.Backbutton} alt="Back" />
            </button>
          )}

          <div className="subscription" id="Pricing">
            <div className="subscription_title">
              Simple, transparent pricing
            </div>
            <div className="plans_wrapper">
              {plans.map((plan, index) => {
                const isSelected = plan.id === activePlanId;
                const interval =
                  plan.name === "Weekly"
                    ? "Weekly"
                    : plan.name === "Half Yearly"
                    ? "Half Yearly"
                    : "Yearly";
                return (
                  <div
                    key={plan.id}
                    className={`plan-box plan-${index + 1} ${
                      isSelected ? "selected-plan" : ""
                    }`}
                    onClick={() => setActivePlanId(plan.id)}
                  >
                    <div>
                      {plan.id === subscribedPlanId && (
                        <div Id="pro">Activated Plan</div>
                      )}
                      <div className="price_details">
                        <div className="price">${plan.amount / 100}</div>
                        <p className="price_interval">/{interval}</p>
                      </div>
                      <div className="description">
                        <div className="plan_name">{plan.name}</div>
                        {subtitles[index] && (
                          <div className="description_subtitle">
                            {subtitles[index]}
                          </div>
                        )}
                      </div>

                      <div className="points_list_full">
                        <div className="points_list_item">
                          <img
                            src={
                              isSelected
                                ? config.check_point
                                : config.colored_check_point
                            }
                            alt=""
                            className="colored_check"
                            width="20px"
                            height="20px"
                            style={{ visibility: "hidden" }}
                            onLoad={(e) =>
                              (e.target.style.visibility = "visible")
                            }
                          />
                          Generate Unlimited Legal Documents
                        </div>
                        <div className="points_list_item">
                          <img
                            src={
                              isSelected
                                ? config.check_point
                                : config.colored_check_point
                            }
                            alt=""
                            className="colored_check"
                            width="20px"
                            height="20px"
                            style={{ visibility: "hidden" }}
                            onLoad={(e) =>
                              (e.target.style.visibility = "visible")
                            }
                          />
                          Ask Unlimited Legal Doubts or Queries
                        </div>
                        <div className="points_list_item">
                          <img
                            src={
                              isSelected
                                ? config.check_point
                                : config.colored_check_point
                            }
                            alt=""
                            className="colored_check"
                            width="20px"
                            height="20px"
                            style={{ visibility: "hidden" }}
                            onLoad={(e) =>
                              (e.target.style.visibility = "visible")
                            }
                          />
                          Summarize & Analyze Legal Cases
                        </div>
                        <div className="points_list_item">
                          <img
                            src={
                              isSelected
                                ? config.check_point
                                : config.colored_check_point
                            }
                            alt=""
                            className="colored_check"
                            width="20px"
                            height="20px"
                            style={{ visibility: "hidden" }}
                            onLoad={(e) =>
                              (e.target.style.visibility = "visible")
                            }
                          />
                          Ads Free Experience
                        </div>
                      </div>
                    </div>
                    <button
                      className="choose_plan"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSubscribe(plan.id);
                      }}
                    >
                      Choose plan
                    </button>
                    <GoogleAuth
                      id="PremiumPageLogin"
                      ref={googleAuthRef}
                      onLoginSuccess={handleLoginSuccess}
                      onLoginFailure={handleLoginFailure}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PricingComponent;
